/**
 * Admin portal color palette — edit ONLY this file to change theme colors app-wide.
 *
 * Flow: colors.ts → tokens.ts → CSS variables (bootstrapTheme) → components via var(--admin-*)
 * Primary: #3C815F · Dark tone: #31674C
 */
export const adminColors = {
	brand: {
		primary: "#3C815F",
		primaryHover: "#357458",
		primaryDark: "#31674C",
		primaryMuted: "rgba(60, 129, 95, 0.12)",
		primaryMutedBg: "rgba(60, 129, 95, 0.06)",
		surface: "#EBF3EF",
		surfaceHover: "#DFEBE4",
		surfaceBorder: "#C2D9C8",
		onPrimary: "#ffffff",
	},
	layout: {
		canvas: "#ffffff",
		surface: "#ffffff",
		surfaceMuted: "#ffffff",
		header: "#EDFFF6",
	},
	text: {
		primary: "#161616",
		muted: "#343434",
		mutedForeground: "#8a8a8a",
		header: "#343434",
	},
	border: {
		default: "#d9d9d9",
		strong: "#e7e7e7",
	},
	semantic: {
		danger: "#FF6E4F",
		dangerHover: "#E86145",
		dangerForeground: "#ffffff",
		dangerSurface: "#ffe2db",
		dangerText: "#c74d51",
		success: "#31674C",
		successForeground: "#ffffff",
		warning: "#f59e0b",
		warningForeground: "#ffffff",
		warningSurface: "#fff4df",
		warningText: "#9a6700",
		warningAccent: "#e2a62f",
		info: "#026cb5",
		infoForeground: "#ffffff",
		actionEdit: "#3C82F6",
		actionEditSurface: "rgba(60, 130, 246, 0.12)",
		disabled: "#9ca3af",
		disabledBackground: "#f3f4f6",
	},
	sidebar: {
		primary: "#3C815F",
		header: "#31674C",
		navActive: "#31674C",
		foreground: "#ffffff",
		border: "rgba(255, 255, 255, 0.35)",
		navHover: "rgba(255, 255, 255, 0.08)",
		navActiveIndicator: "rgba(255, 255, 255, 0.5)",
		scrollbarThumb: "rgba(255, 255, 255, 0.35)",
		scrollbarTrack: "rgba(0, 0, 0, 0.12)",
	},
	chart: {
		orange: "#ef6948",
		purple: "#c12dff",
		teal: "#30b0c7",
		indigo: "#6760ff",
	},
	table: {
		headerBg: "#555555",
		headerText: "#f5f5f5",
		rowBorder: "#ececec",
		bodyText: "#343434",
	},
	tab: {
		inactiveBg: "#F9F9F9",
		inactiveHoverBg: "#F0F0F0",
		inactiveText: "#343434",
	},
	auth: {
		knowledge: "#74c6ff",
		skills: "#ff7faa",
	},
	captcha: {
		border: "#D9D9D9",
		background: "#ffffff",
	},
	dashboard: {
		pastel: {
			iceBlue: "#e4f6ff",
			mint: "#D9E8E0",
			lavender: "#E7E9FE",
			peach: "#FBE6D8",
			sky: "#D7EAF1",
			lilac: "#F1E7FD",
			rose: "#F9E0D9",
			blush: "#F6E8EE",
		},
		icon: {
			teal: "#10A19D",
			purple: "#6C2BD9",
			orange: "#EA580C",
			pink: "#DB2777",
		},
		statSurface: {
			teal: "#e4f6ff",
			purple: "#f7e3ff",
			coral: "#ffe2db",
			indigo: "#eeeaff",
		},
	},
} as const;

export type AdminColors = typeof adminColors;
